import { render } from "./FormKitImage.vue?vue&type=template&id=d8c7bd00"
import script from "./FormKitImage.vue?vue&type=script&lang=js"
export * from "./FormKitImage.vue?vue&type=script&lang=js"

import "./FormKitImage.vue?vue&type=style&index=0&id=d8c7bd00&lang=css"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__